import { Form, FormField, FormLabel, FormSelect, FormInput, Button } from '../ui';
import type { Participant } from '../../types/participant';

interface CouponFormProps {
  participants: Participant[];
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function CouponForm({
  participants,
  onSubmit,
  isLoading,
  onClose,
}: CouponFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <FormField>
        <FormLabel htmlFor="participant_id" required>Participante</FormLabel>
        <FormSelect
          id="participant_id"
          name="participant_id"
          required
        >
          <option value="">Selecione um participante</option>
          {participants?.map((participant) => (
            <option key={participant.id} value={participant.id}>
              {participant.full_name}
            </option>
          ))}
        </FormSelect>
      </FormField>

      <FormField>
        <FormLabel htmlFor="quantity" required>Quantidade</FormLabel>
        <FormInput
          type="number"
          id="quantity"
          name="quantity"
          min="1"
          required
        />
      </FormField>

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button
          type="submit"
          isLoading={isLoading}
          className="sm:col-start-2"
        >
          Adicionar
        </Button>
        <Button
          type="button"
          variant="secondary"
          onClick={onClose}
          className="sm:col-start-1"
        >
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default CouponForm;